import {gsap} from 'gsap';

const ANIMATION_DURATION = 1.25;

class GrowthTilesItem {
    constructor(el) {
        this.el = el;

        const hoverTarget = this.el.dataset.hoverTarget;
        this.targetEl = hoverTarget === 'image' ? this.el.querySelector('.img-wrap img') : this.el.querySelector(`#${hoverTarget}`);
        console.log('this.targetEl');
        console.log(this.targetEl);
        if (!this.targetEl) return;

        gsap.set(this.targetEl, {
            transformOrigin: '50% 50%',
            svgOrigin: '50% 50%',
        });

        const hoverEffect = this.el.dataset.hoverEffect;
        this.effectType = hoverEffect.split('|')[0];
        this.effectValue1 = hoverEffect.split('|')[1];
        this.effectValue2 = hoverEffect.split('|')[2];

        if(this.effectType === 'fadeFrom') {
            console.log('fadeFrom');
            console.log(this.effectValue1);
            console.log(this.effectValue2);
            gsap.set(this.targetEl, {
                opacity: 0,
                x: `${this.effectValue1}`,
                y: `${this.effectValue2}`,
            });
        }

        this.animation = null;

        this.init();
    }

    init() {
        this.el.addEventListener('mouseenter', () => this.startHover());
        this.el.addEventListener('mouseleave', () => this.stopHover());

        this.initialParams = {
            rotation: gsap.getProperty(this.targetEl, "rotation"),
            scaleX: gsap.getProperty(this.targetEl, "scaleX"),
            scaleY: gsap.getProperty(this.targetEl, "scaleY"),
            x: gsap.getProperty(this.targetEl, "x"),
            y: gsap.getProperty(this.targetEl, "y"),
            opacity: gsap.getProperty(this.targetEl, "opacity"),
        };
    }

    startHover() {
        switch (this.effectType) {
            case 'rotate':
            {
                this.animation = gsap.to(this.targetEl, {
                    rotation: this.effectValue1,
                    duration: ANIMATION_DURATION,
                    ease: 'power2.inOut'
                });

                break;
            }

            case 'scale':
            {
                this.animation = gsap.to(this.targetEl, {
                    opacity: 1,
                    scaleX: this.effectValue1,
                    scaleY: this.effectValue2,
                    duration: ANIMATION_DURATION,
                    ease: 'power2.inOut'
                });

                break;
            }

            case 'move':
            {
                this.animation = gsap.to(this.targetEl, {
                    x: this.effectValue1,
                    y: this.effectValue2,
                    duration: ANIMATION_DURATION,
                    ease: 'power2.inOut'
                });

                break;
            }

            case 'fadeFrom': {
                this.animation = gsap.to(this.targetEl, {
                    x: 0,
                    y: 0,
                    opacity: 1,
                    duration: ANIMATION_DURATION * .5,
                    ease: 'power2.inOut'
                });

                break;

            }
        }
    }

    stopHover() {
        switch (this.effectType) {
            case 'fadeFrom': {
                this.animation = gsap.to(this.targetEl, {
                    opacity: 0,
                    duration: ANIMATION_DURATION * .5,
                    ease: 'power2.inOut',
                    onComplete: () => {
                        gsap.set(this.targetEl, {
                            x: `${this.effectValue1}`,
                            y: `${this.effectValue2}`,
                        });
                    }
                });

                break;
            }
            default: {
                gsap.to(this.targetEl, {
                    rotation: this.initialParams.rotation,
                    scaleX: this.initialParams.scaleX,
                    scaleY: this.initialParams.scaleY,
                    x: this.initialParams.x,
                    y: this.initialParams.y,
                    opacity: this.initialParams.opacity,
                    duration: ANIMATION_DURATION,
                    ease: 'power2.inOut'
                });
            }
        }
    }
}

export default GrowthTilesItem;
